import SettingsCore from './settings-core'

export default class CurrencySettings extends SettingsCore {
  constructor (store) {
    super(store)
    this._name = 'currency'
  }

  _getFields () {
    const settings = this._serverSettings[this._name]
    this._throwErrorIfNull(settings, this._name)
    return settings
  }

  // Helper Methods

  get () {
    return this._getFields()
  }

  // Display

  getDisplayName () {
    const fields = this.get()
    return fields && fields.displayName
  }

  getDisplayRate () {
    const fields = this.get()
    return fields && fields.displayRate
  }
  
  getDisplayPrecision () {
    const fields = this.get()
    return fields && fields.displayPrecision
  }

  getDisplayAmount (value) {
    const fields = this.get()
    return value && fields ? (value / fields.displayRate) : value
  }

  // Fiscal

  getFiscalName () {
    const fields = this.get()
    return fields && fields.fiscalName
  }

  getFiscalRate () {
    const fields = this.get()
    return fields && fields.fiscalRate
  }
  
  getFiscalPrecision () {
    const fields = this.get()
    return fields && fields.fiscalPrecision
  }

  getFiscalAmount (value) {
    const fields = this.get()
    return value && fields ? (value / fields.fiscalRate) : value
  }

  // Base

  isCurrencyBase (currencyId) {
    const fields = this.get()
    return currencyId && fields && currencyId === fields.baseId
  }
}
